const LiveChatIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#606062"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M24 24L21.936 17.8085C22.9828 16.0468 23.5859 13.991 23.5859 11.7932C23.5864 5.28 18.3064 0 11.7932 0C5.28 0 0 5.28 0 11.7932C0 18.3064 5.28 23.5864 11.7932 23.5864C13.775 23.5864 15.6409 23.0957 17.28 22.2317L24 24Z" />
    </svg>
  );
};

export default LiveChatIcon;
